export const INQUIRY_CREATE = 'INQUIRY_CREATE'


// WEBPACK FOOTER //
// ./src/constants/Inquiry.js